import React, { useState, useEffect } from 'react';
import { Col, Typography, Row, Card, Layout, Modal } from 'antd';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import ReactPlayer from 'react-player';
import 'react-simple-keyboard/build/css/index.css';
import CustomButton from 'src/components/common/CustomButton';
import { isMobileOnly } from 'react-device-detect';
import { ImgButton } from 'src/components/Header/toolHeaderstyle';
import { useHistory } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';
import FullScreenButton from 'src/components/common/FullScreenButton';
const { Header: HeaderWrapper } = Layout;
const { Title } = Typography;

const MainBlock = styled.div`
  padding: 10px;
  background: #f5f9ff;
  margin-top: 10px;
  height: calc(100vh - 94px);
`;

const TotalBox = styled.span`
  color: rgb(255, 122, 27);
  border: 1px solid #6b5c5c;
  padding: 5px 10px;
  border-radius: 5px;
`;

const ScoreBox = styled.span`
  color: #de3333;
  border: 1px solid #de3333ab;
  padding: 5px 10px;
  border-radius: 5px;
`;

const ListenRepeatPage = ({ data = [], gotoNext = null, title = '' }) => {
  const [total, setTotal] = useState(data.length);
  const [done, setDone] = useState(0);
  const [doneState, setDoneState] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [isDoneOnce, setIsDoneOnce] = useState(false);
  const [doneList, setDoneList] = useState([]);
  const [isComplate, setIsComplate] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (data && data[done]) {
      doneList[done] = true;
      setDoneList(doneList);
      setPlaying(true);
      setDoneState(0);
    }
  }, [data, done, doneList]);

  useEffect(() => {
    if (doneList.filter((d) => d).length === data.length && !isComplate && !playing && doneState > 1) {
      setIsComplate(true);
    }
  }, [data, doneList, isComplate, playing]);

  useEffect(() => {
    if (isComplate && !playing && !isDoneOnce) {
      setTimeout(() => {
        if (gotoNext) {
          gotoNext({});
          setIsDoneOnce(true);
        }
      }, 2000);
    }
  }, [isComplate, playing, isDoneOnce, gotoNext]);

  const onEndPlaying = () => {
    setPlaying(false);
    const dlist = doneList.filter((d) => d);
    if (dlist.length !== data.length && doneState > 1) {
      const listInd = doneList.map((d, i) => (d ? i : -1));
      const filtered = data.map((d, i) => (listInd.includes(i) ? false : i)).filter((d) => d);
      if (filtered.length) {
        setTimeout(setDone(filtered[0]), 1000);
      }
    } else if (doneState < 2) {
      setDoneState((prev) => prev + 1);
      setPlaying(true);
    }
  };
  const handleCloseClick = () => {
    Modal.confirm({
      icon: null,
      title: 'Exit',
      content: (
        <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
          학습이 완료되지 않았습니다. <br /> 종료하면 지금 학습하는 Stage를 <br />
          처음부터 다시 해야 합니다. <br /> 종료 하시겠습니까?
        </Title>
      ),
      onOk: () => history.push('/'),
    });
  };
  return (
    <>
      <HeaderWrapper
        style={{
          background: '#fff',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%',
          height: isMobileOnly && 50,
          lineHeight: isMobileOnly && '50px',
        }}
      >
        <div style={{ paddingTop: 10 }}>
          <Title level={2} style={{ marginLeft: 20, textTransform: 'capitalize', fontSize: isMobileOnly && 20 }}>
            {title}
          </Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileOnly && (
            <div style={{ backgroundColor: '' }}>
              <FullScreenButton
                element={<ImgButton className="header-btn" src="/images/fullscreen_blue.png" alt="back arrow in header" />}
                activeElement={<ImgButton className="header-btn" src="/images/fullscreenExit_blue.png" alt="back arrow in header" />}
              />
            </div>
          )}
          <div key="close" onClick={handleCloseClick}>
            <span style={{ color: '#999', cursor: 'pointer' }}>
              <CloseCircleOutlined
                style={{
                  marginRight: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#424242',
                }}
                key="close"
              />
            </span>
          </div>
        </div>
      </HeaderWrapper>
      <Col className="listenandrepeat" span={24} style={{ textAlign: 'left', margin: 0 }}>
        <MainBlock className="listenandrepeat-scroll scrollscroll">
          <Row gutter={[24, 16]} style={{ padding: 10 }}>
            <Col className="mainheading-spaces" span={16}>
              <Row gutter={[24, 16]} style={{ margin: 0 }}>
                <Col className="mainheading-spaces-col" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                  <Title level={2} ellipsis>
                    <span style={{ color: '#065aa9', marginLeft: 10 }}>Listen and Repeat :</span>{' '}
                  </Title>
                </Col>
              </Row>
            </Col>
            <Col span={8} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 10 }}>
              <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                <TotalBox>
                  {done + 1} / {total}
                </TotalBox>
              </Title>
            </Col>
          </Row>
          <Row gutter={[24, 16]}>
            <Col className="listenandrepeat-content" span={12} style={{ padding: 10 }}>
              <Card
                className="listenandrepeat-content-listing"
                title="Sentence List"
                style={{ width: '100%' }}
                bodyStyle={{ height: 445, overflowY: 'auto' }}
              >
                {data
                  .filter((d, i) => doneList[i] || i <= done)
                  .map((d, i) => (
                    <Title
                      level={4}
                      key={i}
                      onClick={() => setDone(i)}
                      style={{ padding: '5px', cursor: 'pointer', background: done === i ? '#efefef' : '#fff' }}
                    >{`  ${i + 1}. ${d.ans}`}</Title>
                  ))}
              </Card>
            </Col>
            <Col
              className="listenandrepeat-audio"
              span={12}
              style={{ padding: 10, display: 'flex', justifyContent: 'flex-end', flexDirection: 'column' }}
            >
              <div className={'flip-card-container'} style={{ width: '100%', marginBottom: 10 }}>
                <div className="front type2">
                  <p>{data[done]['kor']}</p>
                </div>
              </div>
              <ReactPlayer
                controls
                url={`https://cdn.cloubot.com${data[done]['eng_audio']}`}
                loop={false}
                height={50}
                width={'100%'}
                playing={playing}
                onEnded={onEndPlaying}
                onError={onEndPlaying}
              />
            </Col>
          </Row>
          {isComplate && isDoneOnce ? (
            <div style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: 10 }}>
              <CustomButton
                type="primary"
                style={{ padding: '0 30px', margin: '0 10px' }}
                onClick={() => (gotoNext ? gotoNext({}, true) : null)}
              >
                다음 학습으로 이동
              </CustomButton>
            </div>
          ) : null}
        </MainBlock>
      </Col>
    </>
  );
};

export default ListenRepeatPage;
